import React, { useEffect, useState } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import { Outlet } from 'react-router-dom';
import Loading from './_components/shared/loading';
import { BYPASS_AUTH } from './config';

// Bypass version - no Okta
const RequiredAuthBypass = () => {
  useEffect(() => {
    console.log('🚀 DEV MODE: Authentication bypassed');
    window.localStorage.setItem('urdg', 'dev-mock-token-12345');
  }, []);

  return (<Outlet />);
};

// Normal version - with Okta
const RequiredAuthWithOkta = () => {
  const { oktaAuth, authState } = useOktaAuth();
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    login();
  }, []);

  const login = () => {
    if(window.location.href.indexOf('code=') > 0){
      oktaAuth.token.parseFromUrl().then(
        (tokens) => {
          oktaAuth.tokenManager.setTokens(tokens.tokens);
          window.localStorage.setItem('urdg', tokens.tokens.idToken.idToken);
          setIsAuth(true)
        }
      );

    }
    else{
      oktaAuth.isAuthenticated().then((isAuthenticated)=>{
        console.log(isAuthenticated)
        if(!isAuthenticated){
          oktaAuth.signInWithRedirect();
        }
        else{
          oktaAuth.tokenManager.get('id_token').then((token)=> {
            window.localStorage.setItem('urdg', token);
            setIsAuth(true)
          })
        }
      })
    }
  }

  if (!isAuth) {
    return (<Loading />);
  }

  return (<Outlet />);
};

// Export the right one
export const RequiredAuth = BYPASS_AUTH ? RequiredAuthBypass : RequiredAuthWithOkta;
